<template>
    <div id="not-found">
    </div>
</template>
<script>
    export default {
        name: 'redirect',
        created() {
            window.location.replace("http://www.bupa.com")
        },
    }
</script>
<style lang="less">

</style>